<section class="section py-7">
  <div class="container-xl">
    <div class="row">
      <div class="col text-center">
        <h2 class="h3">How we help your charity win</h2>
        <p class="mb-7">Everything we do is our way of cheering your charity on – here's how.</p>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-lg-4">
        <div class="card-wrapper p-3 py-md-4 px-md-5 h-100">
          <article class="card border-0 h-100">
            <div class="card-body d-md-flex flex-column align-items-start">
              <div class="ratio ratio-1x1 mb-4 thumbnail">
                <img
                  [src]="staticImagesUrl + 'assets/images/demo/homepage/charitybooster-experiences.png'"
                  alt="Products"
                  class="img-contain"
                  width="154"
                  loading="lazy"
                />
              </div>
              <p class="text-primary h6 mb-2 text-uppercase">Products</p>
              <h3 class="h4 card-title">Raising Funds Can Be this Easy.</h3>
              <p class="mb-5">
                From travel packages to virtual experiences, our carefully selected high-quality auction items are a
                sure-fire way to raise the most for your cause.
              </p>

              <a [routerLink]="['/', AppRoutes.Products]" class="btn btn-black btn-sm mt-auto"> Explore Products </a>
            </div>
          </article>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card-wrapper p-3 py-md-4 px-md-5 h-100">
          <article class="card border-0 h-100">
            <div class="card-body d-md-flex flex-column align-items-start">
              <div class="ratio ratio-1x1 mb-4 thumbnail">
                <img
                  [src]="staticImagesUrl + 'assets/images/demo/homepage/charitybooster-experiences-2.png'"
                  alt="Professionals"
                  class="img-contain"
                  width="154"
                  loading="lazy"
                />
              </div>
              <p class="text-primary h6 mb-2 text-uppercase">Professionals</p>
              <h3 class="h4 card-title">The Right Professionals to Help You Win!</h3>
              <p class="mb-5">
                Auctioneers, Event Planners, Platforms and everything in between. Charity booster will connect you with
                the right professionals and services to help you magnify your mission! Want to know more?
              </p>

              <button (click)="loadChatBox()" class="btn btn-black btn-sm mt-auto" type="button">
                Chat with us today
              </button>
            </div>
          </article>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="card-wrapper p-3 py-md-4 px-md-5 h-100">
          <article class="card border-0 h-100">
            <div class="card-body d-md-flex flex-column align-items-start">
              <div class="ratio ratio-1x1 mb-4 thumbnail">
                <img
                  [src]="staticImagesUrl + 'assets/images/demo/homepage/charitybooster-resources.png'"
                  alt="Resources"
                  class="img-contain"
                  width="154"
                  loading="lazy"
                />
              </div>
              <p class="text-primary h6 mb-2 text-uppercase">Resources</p>
              <h3 class="h4 card-title">Champion Your Charity with Our Resources!</h3>
              <p class="mb-5">
                Field Guides, Master Class Videos, Articles and more. Charity booster is working hard to create the best
                resources available for you to help you Champion your Charity. Want an example of what's coming?
              </p>

              <a class="btn btn-black btn-sm mt-auto" href="https://go.charitybooster.com/home-main" target="_blank">
                GET a Free Field Guide
              </a>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</section>
